import { apiClient } from './client';
import type { BuildHistory } from '../../types/entities';

export const buildsApi = {
  /**
    * Trigger a new build for a tenant
    * POST /tenants/:tenantSlug/builds
    */
  triggerBuild: async (tenantSlug: string): Promise<BuildHistory> => {
    return apiClient.post<BuildHistory>(`/tenants/${tenantSlug}/builds`, {});
  },

  /**
    * Get build history for a tenant
    * GET /tenants/:tenantSlug/builds?limit=50
    */
  getHistory: async (tenantSlug: string, limit = 50): Promise<BuildHistory[]> => {
    return apiClient.get<BuildHistory[]>(`/tenants/${tenantSlug}/builds?limit=${limit}`);
  },

  /**
    * Get the latest build for a tenant
    * GET /tenants/:tenantSlug/builds/latest
    */
  getLatest: async (tenantSlug: string): Promise<BuildHistory | null> => {
    try {
      return await apiClient.get<BuildHistory>(`/tenants/${tenantSlug}/builds/latest`);
    } catch {
      return null;
    }
  },

  /**
    * Delete a build history item
    * DELETE /tenants/:tenantSlug/builds/:buildId
    */
  delete: async (tenantSlug: string, buildId: number): Promise<void> => {
    return apiClient.delete<void>(`/tenants/${tenantSlug}/builds/${buildId}`);
  },
};
